import { Timestamp } from '@euler/app/components/Timestamp';
import { StatusColors } from '@euler/components/Colors';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';

export const TimeElapsedLabel = memo(
  ({
    flow,
    style,
    textStyle,
  }: {
    flow: {
      finishedAt?: string | Date | null;
      startedAt?: string | Date | null;
      status?: 'finished' | 'inprogress' | 'pending';
      createdAt?: string | Date | null;
    };
    style?: StyleProp<ViewStyle>;
    textStyle?: StyleProp<TextStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    return flow.status === 'finished' && flow.finishedAt ? (
      <Timestamp
        startTime={flow.finishedAt}
        timestamp={flow.startedAt ?? flow.createdAt ?? undefined}
        label="用时"
        iconSize={rpx(10)}
        iconColor={StatusColors.Success}
        style={style}
        labelStyle={[
          {
            color: StatusColors.Success,
            fontWeight: '500',
            fontSize: rpx(10),
          },
          textStyle,
        ]}
        css={`
          margin-top: ${rpx(4)}px;
        `}
      />
    ) : null;
  },
);
